module.exports = __webpack_public_path__ + "img/cert-laason-26.fd82dfd0.jpg";